import { FC } from 'react';

import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Autocomplete from 'src/components/Form/Autocomplete';
import TextField from 'src/components/Form/TextField';

const statusItems = [
  { key: 1, label: 'Ativo', value: 'active' },
  { key: 2, label: 'Inativo', value: 'inactive' },
];

const LeadFilters: FC = () => {
  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField name="name" label="Nome" size="small" />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField name="email" label="E-mail" size="small" />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField name="phone" label="Telefone" size="small" />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField name="whatsapp_number" label="WhatsApp" size="small" />
      </Grid>

      <Grid item xs={12}>
        <Autocomplete
          name="status"
          label="Status"
          options={statusItems}
          size="small"
          multiple
        />
      </Grid>
    </>
  );
};

export default LeadFilters;
